<template>
	<div class="profile-overview-card">
		<div class="profile-overview-card__icon">
			<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M81.57 62.32a3.72 3.72 0 003.33-3.93 20 20 0 00-3.56-10.62A11.63 11.63 0 0076.75 44a6.81 6.81 0 10-8.63-10.47 12.53 12.53 0 00-6.5-4.6 8.51 8.51 0 10-8.74 0 13 13 0 00-7.73 6.53 12.34 12.34 0 00-1.51-.73 7.94 7.94 0 10-8.12 0 13.8 13.8 0 00-5.94 4.74 19.4 19.4 0 00-2.38 4.33 5.59 5.59 0 00-5.84 9.49 8.42 8.42 0 00-4.74 5 29.37 29.37 0 00-1.52 8.84 3.21 3.21 0 003.9 3.28c.19 6.07.42 13.75.49 13.49a2.9 2.9 0 00.06.41 3.19 3.19 0 005.1 1.87 3.19 3.19 0 005.11-1.88 2.76 2.76 0 00.06-.4c.05.26.33-7.4.48-13.49a3 3 0 001.77-.11c.16 7.33.64 12.43.66 12.67V83.56a4.12 4.12 0 003.54 3.09h.89a4.07 4.07 0 002.21-1l.1-.09.14.13.19.14a4.08 4.08 0 002.33.79H42.61a4.1 4.1 0 003.55-3.06v-.39V83c0-.27.54-5.85.68-13.74h1.84c.21 8 .59 13.59.6 13.82v.1a4.16 4.16 0 004 3.7h.22a4.2 4.2 0 003.47-2.05 4.17 4.17 0 003.47 2.05h.21a4.18 4.18 0 004-3.74V83c0-.06.29-4.31.5-10.44h1c.12 6.24.52 10.55.55 10.81a3.72 3.72 0 005.92 2.51L73 86a2.27 2.27 0 00.28.18 3.67 3.67 0 005.5-2.74v-.15c0-.16.42-4.52.54-10.73h1.09a3.71 3.71 0 003.14-5.62 25.47 25.47 0 01-1.98-4.62zm-8.64-28.8a4.82 4.82 0 11-4.81 4.81 4.82 4.82 0 014.81-4.81zM50.76 21.63a6.5 6.5 0 116.5 6.5 6.51 6.51 0 01-6.5-6.5zm-17.12 6.25a5.94 5.94 0 115.94 5.94 6 6 0 01-5.94-5.94zm-9 17.27a3.6 3.6 0 11-3.6 3.59 3.59 3.59 0 013.63-3.59zm6.41 23.35a1.2 1.2 0 01-1.19-1.11 31 31 0 00-1-6.79c0 .61-.06 1.38-.1 2.34-.22 5.26-.5 7.47-.58 8 0 6.55-.39 12.83-.39 12.82a1.22 1.22 0 01-.75 1 1.2 1.2 0 01-1.62-1c0-.06-.36-5.43-.4-11.7h-.79c0 6.27-.4 11.64-.4 11.7a1.19 1.19 0 01-2.37 0s-.41-6.17-.4-12.78c-.06-.43-.36-2.61-.58-8 0-.95-.07-1.7-.1-2.31a31.48 31.48 0 00-1 6.76 1.19 1.19 0 11-2.37-.16c.32-5.6 1-12.58 7.56-12.59s7.25 7 7.58 12.59a1.2 1.2 0 01-1.1 1.23zm14.07-1.25c-.07 8.81-.67 15.25-.69 15.53s0 .07 0 .1a2.1 2.1 0 01-1.85 1.77h-.4A2.09 2.09 0 0140.32 83a.13.13 0 010-.06.77.77 0 010-.15.13.13 0 010-.06V67.25h-1.43V82.95A2.09 2.09 0 0137 84.66h-.4A2.11 2.11 0 0134.76 83v-.1-.1c0-.27-.57-6.19-.68-14.43a3 3 0 00.18-1.26 29.37 29.37 0 00-1.52-8.84 10.31 10.31 0 00-1-1.87 25 25 0 001-6.82 16.28 16.28 0 00-.2-2.6 22.39 22.39 0 00-1.13 5.75 2.06 2.06 0 01-1.34 1.8A7.44 7.44 0 0028 53.25a5.57 5.57 0 00.84-8.25 17.81 17.81 0 012.35-4.41c2.25-3 5.23-4.71 8.39-4.71 3.15 0 6.14 1.67 8.39 4.71a22.33 22.33 0 013.91 11.8 2.08 2.08 0 01-1.94 2.22h-.14a2.09 2.09 0 01-2.08-1.94A22.06 22.06 0 0046.6 47a16.28 16.28 0 00-.2 2.6c0 7.49 4.23 14.45 4.27 14.52a2.07 2.07 0 01-1.77 3.17zM61 84.86a2.17 2.17 0 01-2.27-1.81c-.07-.62-.64-9.6-.73-21.32h-1.47c-.06 11.33-.7 21-.71 21.14a2.15 2.15 0 01-4.29 0c0-.08-.4-6.1-.6-14.16a4 4 0 001.53-1.55 4.1 4.1 0 00-.08-4.16 32.23 32.23 0 01-2.79-6.39h.49a4.08 4.08 0 003.79-4.35 24.23 24.23 0 00-4.29-12.86 15.46 15.46 0 00-2.77-2.87 11 11 0 0110.45-6.29 11 11 0 019.63 4.93 6.74 6.74 0 00-.77 3.13 6.82 6.82 0 003 5.65A10.94 10.94 0 0066 46.14 31.07 31.07 0 0064.91 41c0 1.11-.11 2.5-.19 4.23 0 .85-.07 1.64-.1 2.4a.87.87 0 00-.09.11A20 20 0 0061 58.39a3.72 3.72 0 003.33 3.93 26.21 26.21 0 01-2.07 4.62A3.75 3.75 0 0063.48 72c-.21 6.34-.5 10.77-.5 10.84A2.17 2.17 0 0161 84.86zm19.49-14.31h-3.06c-.06 7.14-.54 12.36-.57 12.59a1.69 1.69 0 01-3.36 0V70.55h-1.13V83a1.69 1.69 0 01-1.52 1.68A1.69 1.69 0 0169 83.23a.28.28 0 010-.09c0-.23-.51-5.45-.57-12.59h-3.05A1.7 1.7 0 0163.94 68c.34-.23 4.42-8.41 3.3-13.88a18.35 18.35 0 00-.91 4.66 1.68 1.68 0 11-3.33-.25c.37-6.3 3.61-13.18 10-13.38 6.36.21 9.59 7.07 10 13.38a1.68 1.68 0 11-3.36.23 18.43 18.43 0 00-.91-4.66 13 13 0 00-.16 2.11c0 6.07 3.42 11.71 3.46 11.77a1.7 1.7 0 01-1.54 2.57z"/></svg>
		</div>
		<div v-if="storeClone.guests != null && storeClone.guests.length > 0">
			<div>
				<h3 class="profile-overview-card__header">
					<span>{{ $t('profile.overviewGuestsTitle') }}</span>
					<span>({{ storeClone.guests.length }})</span>
				</h3>
				<span class="profile-overview-card__text">
					{{ $t('profile.overviewGuestsText') }}
				</span>
				<span>
					<strong>{{ $t('profile.overviewGuestsSubtitle') }}</strong>
				</span>

				<div class="profile-overview-card__guestlist">
					<div
						class="profile-overview-card__guestitem"
						v-for="guest in storeClone.guests"
						:key="guest.id"
					>
						<router-link
							class="profile-overview-card__guestlink"
							:to="{ name: 'guests-edit', params: { id: guest.guestlid } }"
						>
							{{ guest.name.charAt(0) }}{{ guest.lastname.charAt(0) }}
						</router-link>
					</div>
				</div>

				<div class="profile-overview-card__actions">
					<router-link :to="{ name: 'guests' }">
						<Button color="dark" size="small">
							{{ $t('profile.overviewGuestsCreate') }}
						</Button>
					</router-link>
					<router-link :to="{ name: 'guests' }">
						<Button size="small">
							{{ $t('profile.overviewGuestsShowAll') }}
						</Button>
					</router-link>
				</div>
			</div>
		</div>
		<div v-else>
			<h3 class="profile-overview-card__header">
				{{ $t('profile.overviewGuestsTitle') }}
			</h3>
			<span>
				<strong>{{ $t('profile.overviewNoGuestsSubtitle') }}</strong>
			</span>
			<span class="profile-overview-card__text">
				{{ $t('profile.overviewNoGuestsText') }}
			</span>
			<router-link :to="{ name: 'guests' }">
				<Button size="small">{{ $t('profile.overviewNoGuestsLink') }}</Button>
			</router-link>
		</div>
	</div>
</template>

<script>
import store from '../../vueX/store'
import Button from '../../components/atoms/Button'

export default {
	name: 'ProfileGuestOverviewCard',
	store,
	components: {
		Button
	},
	data() {
		return {
			storeClone: {}
		}
	},
	methods: {},
	computed: {},
	created() {
		this.storeClone = { ...this.$store.state.user }
	}
}
</script>

<style scoped lang="scss">
.profile-overview-card {
	background: #fff;
	padding: 60px 40px 40px 40px;
	position: relative;
	box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
	text-align: center;
	margin-top: 30px;
	@include for-tablet-portrait-up {
		margin-top: 0;
	}
	&__icon {
		width: 100px;
		height: 100px;
		border-radius: 100px;
		background: $colorPrimary6;
		top: 0;
		position: absolute;
		left: 50%;
		transform: translate(-50%, -50%);
		box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
		display: flex;
		justify-content: center;
		svg {
			fill: $colorWhite;
			width: 80px;
		}
	}
	&__header {
		font-size: 24px;
		letter-spacing: 0;
		line-height: 28px;
		font-weight: 400;
		margin-bottom: 10px;
		span {
			display: inline-block;
		}
		span:last-child {
			color: #949eb1;
			margin-left: 5px;
		}
	}
	&__actions {
		display: flex;
		justify-content: space-around;
	}

	&__guestlist {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		margin: 10px 0 20px 0;
	}
	&__guestitem {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 40px;
		height: 40px;
		border-radius: 100px;
		background: #7f8ba1;
		border: 5px solid #fff;
		margin-left: -12px;
		position: relative;
		&:first-child {
			margin-left: 0;
		}
	}
	&__guestlink {
		color: #fff;
		text-decoration: none;
		font-size: 12px;
		font-weight: 600;
		letter-spacing: 0;
		line-height: 16px;
		padding: 10px;
		display: block;
	}
	&__text {
		display: block;
		padding: 10px 0;
	}
}
</style>
